<template>
  <div id="contact">
    <h2 class="text-center">Contact Information</h2>
    <div class="row">
      <div class="col s12">
        <div class="col s12 l6">
          <div class="row">
            <div class="col s12">
              <div class="col s12 m6 l6">
                <div class="card hoverable">
                  <div class="card-image">
                    <a href="/img/t-shirt-printer.2996b697.png">
                      <img
                        src="~@/assets/pics/t-shirt-printer.png"
                        alt="sample"
                      />
                    </a>
                  </div>
                </div>
              </div>

              <div class="col s12 m6 l6">
                <div class="card hoverable">
                  <div class="card-image">
                    <a href="/img/printer.3ef7b518.jpg">
                      <img src="~@/assets/pics/printer.jpg" alt="sample" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col s12">
              <div class="col s12 m6 l6">
                <div class="card hoverable">
                  <div class="card-image">
                    <a href="/img/stationery-products.f7498d40.jpg">
                      <img
                        src="~@/assets/pics/stationery-products.jpg"
                        alt="sample"
                      />
                    </a>
                  </div>
                </div>
              </div>

              <div class="col s12 m6 l6">
                <div class="card hoverable">
                  <div class="card-image">
                    <a href="/img/graphic-design.b46b129b.jpg">
                      <img
                        src="~@/assets/pics/graphic-design.jpg"
                        alt="sample"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col s12 l6">
          <div class="card">
            <div class="card-content">
              <h4 class="text-center">Contact Us</h4>
              <div class="form">
                <form @submit.prevent="submit">
                  <div class="row">
                    <div class="col s12">
                      <div class="col m3">
                        <label for=""></label>
                        <select class="browser-default" v-model="title">
                          <option value="" disabled selected>Title</option>
                          <option value="1">Dr</option>
                          <option value="2">Miss</option>
                          <option value="3">Ms</option>
                          <option value="4">Mr</option>
                          <option value="5">Mrs</option>
                          <option value="6">Sir</option>
                        </select>
                      </div>
                      <div class="input-field col m9">
                        <input id="text" type="text" class="validate" v-model="name" />
                        <label for="text">Name</label>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col s12">
                      <div class="input-field col s12 l6">
                        <input id="email" type="email" class="validate" v-model="email" />
                        <label for="email">Email</label>
                      </div>

                      <div class="input-field col s12 l6">
                        <input
                          id="icon_telephone"
                          type="tel"
                          class="validate"
                          v-model="tel"
                        />
                        <label for="icon_telephone">Telephone</label>
                      </div>
                    </div>
                  </div>
                  <div class="input-field col s12">
                    <textarea
                      id="textarea1"
                      class="materialize-textarea"
                      v-model="comment"
                    ></textarea>
                    <label for="textarea1">Comment</label>
                  </div>
                  <div>
                    <button
                      class="btn waves-effect waves-light"
                      style="float:right;"
                      type="submit"
                      name="action"
                    >
                      <b>
                        Submit
                        <i class="far fa-paper-plane"></i
                      ></b>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col l12">
      <div class="card">
        <div class="card-content">
          <div class="row">
            <div class="col s12">
              <div class="col s12 m4 l5">
                <address>
                  <h4>Visit us at</h4>
                  <i class="fas fa-map-marker-alt"></i>
                  Madina Presec Primary Road,<br />
                  <i class="fas fa-map-marker-alt"></i>
                  Opposite Presec Primary School<br />
                  <i class="fas fa-map-marker-alt"></i>
                  Accra- Ghana.
                  <span>
                    <br /><br />
                    <b>Call us on:</b><br />
                    <a href="tel:0248 157 274"
                      ><i class="fas fa-phone-alt"></i> +233 24 815 7274</a
                    ><br />
                    <a href="tel:0545 051 244"
                      ><i class="fas fa-phone-alt"></i> +233 54 505 1244</a
                    >
                    <br />
                    <br />
                    <b>Email us:</b><br />
                    <a href="mailto:sheimage@gmail.com"
                      ><i class="fas fa-envelope"></i> sheimage@gmail.com</a
                    >
                  </span>
                  <br /><br />
                  <span>
                    <b>Business Hours:</b><br />
                    <i class="far fa-calendar-alt"></i> Monday - Friday<br />
                    <i class="far fa-clock"></i> 07:30am ~ 06:00pm
                  </span>
                </address>
              </div>

              <div class="col s12 m1 l2"></div>
              <div class="col s12 m6 l5">
                <h4>Location</h4>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3970.313126789126!2d-0.17362068523357677!3d5.667783995891651!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xfdf9ceb3bff3b55%3A0x60346eaf01dde457!2sSheImage%20Print%20%26%20Stationery!5e0!3m2!1sen!2sgh!4v1594592055635!5m2!1sen!2sgh"
                  width="400"
                  height="300"
                  frameborder="0"
                  style="border:0;"
                  allowfullscreen=""
                  aria-hidden="false"
                  tabindex="0"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'

export default {
  data: function(){
    return{
      title: "",
      name: "",
      email: "",
      tel: "",
      comment: ""
    }
  },
methods: {
  submit(){
    const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary',
    cancelButton: 'btn btn-danger m-3'
  },
  buttonsStyling: false
})

swalWithBootstrapButtons.fire({
  title: 'Confirm',
  text: "Are you sure you want to submit your details?",
  icon: 'warning',
  showCancelButton: true,
  confirmButtonText: 'Yes, send!',
  cancelButtonText: 'No, cancel!',
  reverseButtons: true
}).then((result) => {
  if (result.value) {
    swalWithBootstrapButtons.fire(
      'Success!',
      'Your details have been submitted.',
      'success',
      this.cancel()
    )
  } else if (
    /* Read more about handling dismissals below */
    result.dismiss === Swal.DismissReason.cancel
  ) {
    swalWithBootstrapButtons.fire(
      'Cancelled',
      'Your details were not submitted',
      'error'
    )
  }
})
  },
  cancel(){
      this.title = "",
      this.name = "",
      this.email = "",
      this.tel = "",
      this.comment = ""
  }
}

};
</script>

<style scoped>
h2 {
  text-decoration: underline;
  font-weight: 700;
}

address {
  padding-left: 40px;
}

a:link {
  color: black;
}

a:hover {
  color: #009688;
}

img {
  width: 361px;
  height: 211px;
}

@media screen and (max-width: 786px) {
  address {
    padding-left: 0;
  }

  iframe {
    width: 90%;
  }
}

@media screen and (max-width: 601px) {
  img {
    width: auto;
    height: auto;
  }
}
</style>
